import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Field } from '../components/Field';
import { ViewHeader } from '../components/ViewHeader';
import { useWorkspace } from '../hooks/useWorkspace';
import { useLang } from '../hooks/useLang';
import { REGIONAL_FEDERATIONS, LIMITS } from '../../domain/constants';
import { t } from '../../i18n';
import type { WorkspaceStore } from '../../domain/store';

export function RegistrationDataView({ store, hidden }: { store: WorkspaceStore; hidden: boolean }) {
  const workspace = useWorkspace(store);
  useLang();
  const { meta, contact } = workspace;

  return (
    <section className="mx-auto flex max-w-[1180px] flex-col gap-4 p-4" hidden={hidden}>
      <ViewHeader title={t('registrationData.title')} lede={t('registrationData.lede')} />

      <Card>
        <CardHeader>
          <CardTitle>{t('registrationData.club.title')}</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field
            scope="meta"
            store={store}
            target={meta}
            spec={{
              label: t('meldedaten.field.club'),
              key: 'club',
              maxLength: LIMITS.club,
              required: true,
              wide: true,
              placeholder: 'RSV 1910 Langenselbold',
            }}
          />
          <Field
            scope="meta"
            store={store}
            target={meta}
            commit={false}
            spec={{
              label: t('meldedaten.field.regionalFederation'),
              key: 'lv',
              required: true,
              options: REGIONAL_FEDERATIONS.map(([n, c]) => [n, `${n} (${c})`] as const),
            }}
          />
          <Field
            scope="meta"
            store={store}
            target={meta}
            spec={{ label: t('meldedaten.field.federation'), key: 'federation', maxLength: LIMITS.federation, placeholder: 'HRV' }}
          />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{t('registrationData.contact.title')}</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.firstName'), key: 'firstName', maxLength: LIMITS.name, required: true }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.lastName'), key: 'lastName', maxLength: LIMITS.name, required: true }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.uciId'), key: 'uciId', maxLength: LIMITS.uciId, mono: true }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.email'), key: 'email', maxLength: LIMITS.email, type: 'email', required: true }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.street'), key: 'street', maxLength: LIMITS.street }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.phone'), key: 'phone', maxLength: LIMITS.phone, type: 'tel' }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.postalCode'), key: 'postalCode', maxLength: LIMITS.postalCode, mono: true }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.city'), key: 'city', maxLength: LIMITS.city }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.countryCode'), key: 'countryCode', maxLength: LIMITS.countryCode, mono: true, placeholder: 'D' }} />
          <Field scope="contact" store={store} target={contact} spec={{ label: t('field.fax'), key: 'fax', maxLength: LIMITS.fax }} />
        </CardContent>
      </Card>
    </section>
  );
}
